<!-- Loading Indicator -->
@if (isLoading()) {
<div class="loading-container">
  <div class="loading-spinner"></div>
  <p>Loading, please wait...</p>
</div>
}

<!-- Main Content -->
<div [hidden]="isLoading()">
  <router-outlet></router-outlet>
</div>

<app-session-warning-modal
  [showCountdown]="showCountdown()"
  (continueSession)="continueSession()"
  (handleLogout)="handleLogout()"
></app-session-warning-modal>

<app-error-logout-modal
  [showModal]="showErrorLogout()"
  (handleLogout)="handleErrorLogout()"
></app-error-logout-modal>

<app-signup-logout-modal
  [showModal]="showSignupLogout()"
  (handleLogout)="handleSignupLogout()"
></app-signup-logout-modal>

<app-byoid-provisioning-modal
  [showModal]="showByoidProvisioning()"
  (handleLogout)="handleByoidProvisioningLogout()"
></app-byoid-provisioning-modal>
